(function () {
  'use strict';

  var cache = {};

  function fetchSwatchData(collectionHandle) {
    if (cache[collectionHandle]) {
      return cache[collectionHandle];
    }

    var promise = fetch('/collections/' + collectionHandle + '?sections=cross-product-swatches')
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Failed to fetch swatches for ' + collectionHandle);
        }
        return response.json();
      })
      .then(function (data) {
        var html = data['cross-product-swatches'];
        if (!html) return [];
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var text = doc.body.textContent.trim();
        try {
          return JSON.parse(text);
        } catch (e) {
          console.warn('CrossProductSwatches: Could not parse JSON for', collectionHandle, e);
          return [];
        }
      })
      .catch(function (err) {
        console.warn('CrossProductSwatches:', err);
        return [];
      });

    cache[collectionHandle] = promise;
    return promise;
  }

  function getProductCard(container) {
    return container.closest('.product__grid-item');
  }

  function setImageSrc(img, url) {
    img.src = url;
    img.srcset = url;
    img.setAttribute('data-src', url);
    img.setAttribute('data-srcset', '');
  }

  function swapImage(card, primaryUrl, secondaryUrl, productUrl) {
    if (!card) return;

    var primaryImg = card.querySelector('.product__imageContainer img:not(.secondary)');
    if (!primaryImg) return;

    var secondaryImg = card.querySelector('.product__imageContainer img.secondary');
    var productWrap = card.querySelector('.product-wrap');

    // Store original data on first swap
    if (!card.hasAttribute('data-original-primary-src')) {
      card.setAttribute('data-original-primary-src', primaryImg.src);
      card.setAttribute('data-original-primary-srcset', primaryImg.srcset || '');
      card.setAttribute('data-original-primary-datasrc', primaryImg.getAttribute('data-src') || '');
      card.setAttribute('data-original-primary-datasrcset', primaryImg.getAttribute('data-srcset') || '');
      if (secondaryImg) {
        card.setAttribute('data-original-secondary-src', secondaryImg.src);
        card.setAttribute('data-original-secondary-srcset', secondaryImg.srcset || '');
        card.setAttribute('data-original-secondary-datasrc', secondaryImg.getAttribute('data-src') || '');
        card.setAttribute('data-original-secondary-datasrcset', secondaryImg.getAttribute('data-srcset') || '');
      }
      // Track whether the card originally had secondary swap
      if (productWrap && productWrap.classList.contains('has-secondary-image-swap')) {
        card.setAttribute('data-original-had-secondary', '');
      }
    }

    // Swap primary image
    setImageSrc(primaryImg, primaryUrl);

    // Swap or hide secondary image
    if (secondaryImg) {
      if (secondaryUrl) {
        setImageSrc(secondaryImg, secondaryUrl);
        // Ensure hover swap is enabled
        if (productWrap) productWrap.classList.add('has-secondary-image-swap');
      } else {
        // New color has no secondary image — disable hover swap
        if (productWrap) productWrap.classList.remove('has-secondary-image-swap');
      }
    }

    // Update product links
    var imageLink = card.querySelector('.product__imageContainer > a');
    var hiddenLink = card.querySelector('a.hidden-product-link');
    if (imageLink) {
      if (!card.hasAttribute('data-original-url')) {
        card.setAttribute('data-original-url', imageLink.getAttribute('href'));
      }
      imageLink.setAttribute('href', productUrl);
    }
    if (hiddenLink) {
      hiddenLink.setAttribute('href', productUrl);
    }
  }

  function restoreImage(card) {
    if (!card || !card.hasAttribute('data-original-primary-src')) return;

    var primaryImg = card.querySelector('.product__imageContainer img:not(.secondary)');
    if (primaryImg) {
      primaryImg.src = card.getAttribute('data-original-primary-src');
      primaryImg.srcset = card.getAttribute('data-original-primary-srcset');
      primaryImg.setAttribute('data-src', card.getAttribute('data-original-primary-datasrc'));
      primaryImg.setAttribute('data-srcset', card.getAttribute('data-original-primary-datasrcset'));
    }

    var secondaryImg = card.querySelector('.product__imageContainer img.secondary');
    if (secondaryImg && card.hasAttribute('data-original-secondary-src')) {
      secondaryImg.src = card.getAttribute('data-original-secondary-src');
      secondaryImg.srcset = card.getAttribute('data-original-secondary-srcset');
      secondaryImg.setAttribute('data-src', card.getAttribute('data-original-secondary-datasrc'));
      secondaryImg.setAttribute('data-srcset', card.getAttribute('data-original-secondary-datasrcset'));
    }

    // Restore hover swap state
    var productWrap = card.querySelector('.product-wrap');
    if (productWrap) {
      if (card.hasAttribute('data-original-had-secondary')) {
        productWrap.classList.add('has-secondary-image-swap');
      } else {
        productWrap.classList.remove('has-secondary-image-swap');
      }
    }

    // Restore product links
    var originalUrl = card.getAttribute('data-original-url');
    if (originalUrl) {
      var imageLink = card.querySelector('.product__imageContainer > a');
      var hiddenLink = card.querySelector('a.hidden-product-link');
      if (imageLink) imageLink.setAttribute('href', originalUrl);
      if (hiddenLink) hiddenLink.setAttribute('href', originalUrl);
    }
  }

  function trimOverflow(container) {
    // reset any previous trim so this is safe to re-run (resize/orientation)
    var oldInd = container.querySelector('.cross-product-swatches__overflow');
    if (oldInd) oldInd.remove();
    container.querySelectorAll('.cross-product-swatches__swatch').forEach(function (s) {
      if (s.style.display === 'none') s.style.display = '';
    });

    var swatches = container.querySelectorAll('.cross-product-swatches__swatch');
    if (swatches.length === 0) return;

    // Hard cap everywhere (Claude Design S1 / Shane 2026-07-29: ten dots on
    // a desktop card is distracting) — five dots max, '+N' for the rest.
    var HARD_CAP = 5;
    var visibleCount = swatches.length;

    if (window.innerWidth <= 798) {
      // mobile additionally fits to the (nowrap) row width
      var available = container.clientWidth;
      var reservedForIndicator = 28;
      var gap = 6;
      var running = 0;
      visibleCount = 0;
      for (var i = 0; i < swatches.length; i++) {
        var swatchWidth = swatches[i].offsetWidth;
        var needed = running + swatchWidth + (i > 0 ? gap : 0);
        var limit = (i < swatches.length - 1) ? available - reservedForIndicator : available;
        if (needed > limit && visibleCount > 0) break;
        running = needed;
        visibleCount++;
      }
    }

    if (visibleCount > HARD_CAP) visibleCount = HARD_CAP;
    if (visibleCount >= swatches.length) return;

    var hiddenCount = swatches.length - visibleCount;
    for (var j = visibleCount; j < swatches.length; j++) {
      swatches[j].style.display = 'none';
    }

    var indicator = document.createElement('span');
    indicator.className = 'cross-product-swatches__overflow';
    indicator.textContent = '+' + hiddenCount;
    container.appendChild(indicator);
  }

  function renderSwatches(container, products) {
    var currentProductId = parseInt(container.getAttribute('data-current-product-id'), 10);

    // If 0 or 1 products, leave container invisible (opacity: 0) but in flow
    // so titles/prices align with cards that have swatches
    if (products.length <= 1) {
      return;
    }

    var card = getProductCard(container);

    // Move has-secondary-image-swap from the outer card to .product-wrap
    // so the theme's hover toggle only fires over the product area, not swatches.
    // Must be on .product-wrap (not .product-image__wrapper) because the theme's
    // handler does $(currentTarget).find('.product-image__wrapper img').
    if (card && card.classList.contains('has-secondary-image-swap')) {
      var productWrap = card.querySelector('.product-wrap');
      if (productWrap) {
        card.classList.remove('has-secondary-image-swap');
        productWrap.classList.add('has-secondary-image-swap');
      }
    }

    var fragment = document.createDocumentFragment();

    products.forEach(function (product) {
      if (!product.color_name) return;

      var swatch = document.createElement('span');
      swatch.className = 'cross-product-swatches__swatch';
      swatch.setAttribute('title', product.color_name);
      swatch.setAttribute('aria-label', product.color_name);
      swatch.setAttribute('role', 'button');
      swatch.setAttribute('tabindex', '0');
      swatch.setAttribute('data-product-id', product.id);
      swatch.setAttribute('data-product-url', product.url);
      swatch.setAttribute('data-featured-image', product.featured_image || '');
      swatch.setAttribute('data-secondary-image', product.secondary_image || '');

      if (product.color_image) {
        swatch.style.backgroundImage = 'url(' + product.color_image + ')';
      } else if (product.color_hex) {
        swatch.style.backgroundColor = product.color_hex;
      }

      if (product.id === currentProductId) {
        swatch.className += ' cross-product-swatches__swatch--active';
      }

      fragment.appendChild(swatch);
    });

    container.innerHTML = '';
    container.appendChild(fragment);
    container.style.opacity = '1';

    // On mobile, clamp to one row and show "+N" for hidden swatches
    trimOverflow(container);

    // Attach click handler via event delegation on the container
    container.addEventListener('click', function (e) {
      var swatch = e.target.closest('.cross-product-swatches__swatch');
      if (!swatch) return;

      e.preventDefault();
      e.stopPropagation();

      var productId = parseInt(swatch.getAttribute('data-product-id'), 10);
      var productUrl = swatch.getAttribute('data-product-url');
      var featuredImage = swatch.getAttribute('data-featured-image');
      var secondaryImage = swatch.getAttribute('data-secondary-image');

      // Update active state
      var allSwatches = container.querySelectorAll('.cross-product-swatches__swatch');
      allSwatches.forEach(function (s) {
        s.classList.remove('cross-product-swatches__swatch--active');
      });
      swatch.classList.add('cross-product-swatches__swatch--active');

      // Swap or restore image
      if (productId === currentProductId) {
        restoreImage(card);
      } else if (featuredImage) {
        swapImage(card, featuredImage, secondaryImage, productUrl);
      }

      // Keep the quick-add overlay pointing at the selected colour's variants
      if (window.NamaQuickAdd) {
        var qaUrl = productId === currentProductId
          ? container.getAttribute('data-current-product-url')
          : productUrl;
        window.NamaQuickAdd.rebuild(card, qaUrl);
      }
    });
  }

  function init() {
    var containers = document.querySelectorAll('[data-cross-product-swatches]');
    var handleMap = {};

    containers.forEach(function (container) {
      // Skip already-populated containers — but not server-seeded ones
      // (the seed is the product's own single swatch; if siblings exist
      // the fetch below replaces it with the full set)
      if (container.children.length > 0 && !container.hasAttribute('data-seeded')) return;

      var handle = container.getAttribute('data-collection-handle');
      if (!handle) return;

      if (!handleMap[handle]) {
        handleMap[handle] = [];
      }
      handleMap[handle].push(container);
    });

    Object.keys(handleMap).forEach(function (handle) {
      fetchSwatchData(handle).then(function (products) {
        handleMap[handle].forEach(function (container) {
          renderSwatches(container, products);
        });
      });
    });
  }

  // Run on DOMContentLoaded or immediately if already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-clamp rows on resize/orientation (trim only runs at render otherwise)
  var trimTimer;
  window.addEventListener('resize', function () {
    clearTimeout(trimTimer);
    trimTimer = setTimeout(function () {
      document.querySelectorAll('[data-cross-product-swatches]').forEach(trimOverflow);
    }, 150);
  });

  // Expose for re-initialization after AJAX pagination/filtering
  window.CrossProductSwatches = { init: init };
})();
